// get content
export const getContent = (query) => ({
  url: `/content/${query}`,
  method: "GET",
});

// create/update content
export const createContent = (data) => ({
  url: "/admin/content",
  method: "POST",
  body: { ...data },
});

// delete content
export const deleteContent = (query) => ({
  url: `/admin/content?type=${query}`,
  method: "delete",
});
